import { render, staticRenderFns } from "./LimboSearch.vue?vue&type=template&id=05633c36&"
import script from "./LimboSearch.vue?vue&type=script&lang=js&"
export * from "./LimboSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports